module.exports = __webpack_public_path__ + "img/slider.433f2c8.jpg";